module.exports = __webpack_public_path__ + "src/img/playIcon.b27faa19.svg";